interface BrandLogoProps {
  size?: number;
  className?: string;
}

const BrandLogo = ({ size = 32, className = "" }: BrandLogoProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Outer bracelet ring */}
      <circle
        cx="24"
        cy="24"
        r="21"
        stroke="hsl(16, 50%, 58%)"
        strokeWidth="2"
        fill="none"
      />
      {/* Accent arc */}
      <path
        d="M 10 38 A 21 21 0 0 1 10 10"
        stroke="hsl(350, 35%, 65%)"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* B letter */}
      <text
        x="14"
        y="31"
        fontFamily="'Playfair Display', serif"
        fontWeight="700"
        fontSize="18"
        fill="hsl(20, 10%, 15%)"
      >
        B
      </text>
      {/* M letter */}
      <text
        x="25"
        y="31"
        fontFamily="'Playfair Display', serif"
        fontWeight="700"
        fontSize="18"
        fill="hsl(16, 50%, 58%)"
      >
        M
      </text>
    </svg>
  );
};

export default BrandLogo;
